export const  SCREEN_SHARE_STORE_NAME = 'ScreenShareStore';


export enum API_VARIABLES {
  MEETING_ID = '{meetingId}',
  MEETINGS = '{meetings}',
  STUDENT_ID = '{personId}',
  CLASS_ID = '{classId}',
  SERVICE = '{service}'
}

//-- Events
export const SCREEN_SHARE_EVENTS = {
  CLICK_CALL_START: 'CLICK_CALL_START',                 //-- From menu - Select Option Call
  CALL_STARTED: 'CALL_STARTED',                         //-- Called Initiated
  CREATE_CALL_COMMAND: 'CREATE_CALL_COMMAND',           //-- Create command for a Call
  PARTICIPANT_CHANGED: 'PARTICIPANT_CHANGED',
  SHOW_SPLASH: 'SHOW_SPLASH',
  HIDE_SPLASH: 'HIDE_SPLASH',


  CALLS_CHANGE_TIME: 'CALLS_CHANGE_TIME',
  ON_CHANGE_MUTE_DEVICE: 'ON_CHANGE_MUTE_DEVICE',
  ON_NUMBER_PARTICIPANTS_CHANGED: 'ON_NUMBER_PARTICIPANTS_CHANGED',
}

export const ACTIONS = {
  START_CALL: 'startScreenShare',
  END_CALL: 'endScreenShare',
  MUTE_CALL: 'muteCall',
}

export const MUTATIONS = {
  ON_JITSI_INIT_CALL: 'jitsiInitCall',
  END_SCREEN_SHARE: 'cleanScreenShareStarted',
  UPDATE_PARTICIPANTS: 'updateParticipant',
  REMOVE_PARTICIPANT: 'removeParticipant',
  SET_CONFERENCE: 'updateConference',
  CLEAN_CONFERENCE: 'cleanConference',
  LOCAL_IS_ON_SCREEN_SHARE: 'updateLocalIsOnScreenShare',
  REMOTE_IS_ON_SCREEN_SHARE: 'updateRemoteIsOnScreenShare',
}

export const _SCREEN_SHARE_STORE = {
  NAME: SCREEN_SHARE_STORE_NAME,
  MUTATIONS: {
    ON_JITSI_INIT_CALL: `${SCREEN_SHARE_STORE_NAME}/${MUTATIONS.ON_JITSI_INIT_CALL}`,
    END_SCREEN_SHARE: `${SCREEN_SHARE_STORE_NAME}/${MUTATIONS.END_SCREEN_SHARE}`,
    UPDATE_PARTICIPANTS: `${SCREEN_SHARE_STORE_NAME}/${MUTATIONS.UPDATE_PARTICIPANTS}`,
    REMOVE_PARTICIPANT: `${SCREEN_SHARE_STORE_NAME}/${MUTATIONS.REMOVE_PARTICIPANT}`,
    SET_CONFERENCE: `${SCREEN_SHARE_STORE_NAME}/${MUTATIONS.SET_CONFERENCE}`,
    CLEAN_CONFERENCE: `${SCREEN_SHARE_STORE_NAME}/${MUTATIONS.CLEAN_CONFERENCE}`,
    LOCAL_IS_ON_SCREEN_SHARE: `${SCREEN_SHARE_STORE_NAME}/${MUTATIONS.LOCAL_IS_ON_SCREEN_SHARE}`,
    REMOTE_IS_ON_SCREEN_SHARE: `${SCREEN_SHARE_STORE_NAME}/${MUTATIONS.REMOTE_IS_ON_SCREEN_SHARE}`,
  },
  ACTIONS: {
  }
}
